import { StarIcon } from "@heroicons/react/24/solid";
import Image from "next/image";
import React from "react";

interface Props {
  userName: string;
  photo: string;
  review: string;
  relative_date: string;
  rating: number;
}

function TestimonialsCard({ userName, photo, review, relative_date, rating }: Props) {
  return (
    <div
      className="min-w-[320px] shadow-md p-6 rounded-md hover:shadow-lg 
    hover:scale-105 transform transition duration-300 ease-out text-center z-10"
      role="listitem"
    >
      <div className="flex space-x-4 items-center">
        <div className="relative">
          <Image
            src={photo}
            alt={`Foto de perfil de ${userName}`}
            width={70}
            height={70}
            className="rounded-full object-cover"
            loading="lazy"
          />
        </div>
        <div className="text-left">
          <p className="text-base md:text-lg font-bold">{userName}</p>
          <p className="text-xs text-gray-500 pb-1">{relative_date}</p>
          <div className="flex">
            {Array(rating)
              .fill(0)
              .map((_, i) => (
                <StarIcon key={i} className="text-violet-700 h-[18px]" />
              ))}
          </div>
        </div>
      </div>
      <p className="mt-4 text-sm text-left line-clamp-[10]">{review}</p>
    </div>
  );
}

export default TestimonialsCard;
